import { get, omit, forEach, castArray } from 'lodash';

const PUBLISH_PATH = 'meta.publish';

export default function publishMiddleware(publish) {
  return () => next => action => {
    const destinations = castArray(get(action, PUBLISH_PATH, []));
    if (!destinations.length) {
      return next(action);
    }

    forEach(destinations, destination => publish(destination, omit(action, PUBLISH_PATH)));
  };
}
